"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGenerateBonusTypes = exports.BonusTypes = void 0;
var react_1 = require("react");
var next_intl_1 = require("next-intl");
var BonusTypes;
(function (BonusTypes) {
    BonusTypes["FREESPINS"] = "FREESPINS";
    BonusTypes["BONUSES"] = "BONUSES";
})(BonusTypes = exports.BonusTypes || (exports.BonusTypes = {}));
var useGenerateBonusTypes = function () {
    var t = (0, next_intl_1.useTranslations)('translation');
    return (0, react_1.useMemo)(function () {
        return Object.values(BonusTypes).map(function (key) { return ({
            label: t(key).toUpperCase(),
            value: key,
        }); });
    }, [t]);
};
exports.useGenerateBonusTypes = useGenerateBonusTypes;
